export default __webpack_public_path__ + "static/media/WordPressPortfolio.6536933b.png";